module.exports = __webpack_public_path__ + "img/Kdiamonds.4f25802d.jpg";